"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  importBillUpload: {
    confirm: 'confirm',
    blNoTips: '"Bill of Lading Number (up to 50 numbers)" For multiple numbers, use a half width English comma to separate them: Bill of Lading Number, Bill of Lading Number.',
    pleaseCheckData: 'Please check data',
    limit10Data: 'Select no more than ten records each time!',
    blNoAndContainerNo: 'BlNo:',
    pod: 'Pod',
    bankSlipUploadApplyInvoice: 'Bank Slip Upload/Apply Invoice',
    tips: 'CNTAO do not open this function, if there is any problem, please contact relevant personnel of the corresponding port company.',
    paymentNo: 'Payment No',
    paymentWay: 'Payment Way',
    paymentInCny: 'Payment in CNY',
    paymentInUsd: 'Payment in USD',
    paymentInKrw: 'Payment in KRW',
    paymentInHkd: 'Convert HKD To Pay',
    originalCurrencyPay: 'Original Currency To Pay',
    onlycny: 'Only CNY',
    invoiceWay: 'Invoice Way',
    bankSlipDOF: '换单费DOF现场支付',
    extract: 'Including the import container pick-up deposit',
    receiveEmail: 'Receive Email',
    address: 'Address',
    phone: 'Phone',
    accountBank: 'Account Bank',
    account: 'Account',
    bankUsd: 'Bank(USD)',
    accountUsd: 'Account(USD)',
    invoiceTaxNo: 'Invoice Tax No',
    remark: 'Remark',
    emailNotNull: 'Receive Email Not Null',
    addressNotNull: 'address Not Null',
    phoneNotNull: 'phone Not Null',
    accountBankNotNull: 'account Bank Not Null',
    accountNotNull: 'Account Not Null',
    invoiceTaxNoNotNull: 'Invoice Tax No Not Null',
    invoiceWayNotNull: 'InvoiceWay Not Null',
    paymentNoNotNull: 'PaymentNo Not Null',
    blNoNotNull: 'BlNo Not Null',
    podNotNull: 'Pod Not Null',
    saveSuccessfully: 'Save Successfully',
    applicationInProgress: 'Please do not repeat your application!',
    invoiceAndPaymentAutoProcessing: 'This order number has already been invoiced and accepted. There is no need to upload the payment slip again. Our backend system will automatically retrieve the payment information and clear the account. Please just monitor the telegraphic release status.',
    noRate: 'The exchange rate is not perfect, please contact the administrator!',
    modPaymentNo: 'Please change the payment header to the full name of the actual payment company',
    extractAmount: 'Deposit:',
    noSecondOpr: 'Secondary applications are not permitted.'
  },
  importBillUploadTable: {
    no: 'No',
    amount: 'Amount',
    paymentStatus: 'Payment Status',
    applyInvoice: 'Apply Invoice',
    orderNo: 'BK NO.',
    blNo: 'BL NO.',
    vesselCode: 'Vessel Code',
    voyageNo: 'Voyage No',
    voyageLeg: 'Voyage Leg',
    pol: 'POL',
    etd: 'ETD Org',
    pod: 'POD',
    eta: 'ETA',
    del: 'DEL',
    bankSlipAuditRemark: 'Bank Slip Audit Remark',
    auditRemark: 'Invoice Audit Remark'
  }
};